import { z } from "zod";
import { LocationType } from "../address";

export enum OrderType {
  PICKUP = "Pickup",
  DELIVERY = "Delivery",
}

export enum OrderStatus {
  PENDING = "Pending",
  PROCESSING = "Processing",
  SHIPPED = "Shipped",
  DELIVERED = "Delivered",
  CANCELLED = "Cancelled",
  RETURNED = "Returned",
}

function startOfTodayLocal(): Date {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
}

function parsePreferredDateLocal(s: string): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (!m) return null;
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
}

export function withOrderTimingValidation<T extends z.ZodTypeAny>(
  schema: T,
  validatePastDate = true,
) {
  return schema.superRefine((input, ctx) => {
    if (!input.preffered_date) {
      ctx.addIssue({
        path: ["preffered_date"],
        code: z.ZodIssueCode.custom,
        message: "validation.order.preferred_date_required_all",
      });
    } else if (typeof input.preffered_date === "string") {
      const pd = parsePreferredDateLocal(input.preffered_date);
      if (validatePastDate && pd && pd < startOfTodayLocal()) {
        ctx.addIssue({
          path: ["preffered_date"],
          code: z.ZodIssueCode.custom,
          message: "validation.order.preferred_date_past",
        });
      }
    }

    if (input.type === OrderType.DELIVERY) {
      const isOffice =
        input.person?.address?.location_type === LocationType.OFFICE;

      if (isOffice && !input.preffered_time) {
        ctx.addIssue({
          path: ["preffered_time"],
          code: z.ZodIssueCode.custom,
          message: "validation.order.preferred_time_required",
        });
      }
    } else if (input.type === OrderType.PICKUP) {
      if (!input.preffered_time) {
        ctx.addIssue({
          path: ["preffered_time"],
          code: z.ZodIssueCode.custom,
          message: "validation.order.preferred_time_required_pickup",
        });
      }
    }
  });
}
